
export const loadState = (key) => {
  try {
    const serializedState = sessionStorage.getItem(key);

    if (serializedState === null) {
      return undefined;
    }

    return JSON.parse(serializedState);
  } catch (error) {
    return undefined;
  }
};

export const saveState = (state, key) => {
  if(state) {
    const serializedState = JSON.stringify(state);
    sessionStorage.setItem(key, serializedState);
  } else {
    sessionStorage.removeItem(key)
  }
};
